import React from 'react';
import ReactDOM from 'react-dom/client';
import AppGrpcWeb from './AppGrpcWeb.tsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppGrpcWeb />
  </React.StrictMode>
);
